import { IS_FOCUSABLE_ATTRIBUTE } from './FocusZone';
export var FocusZoneMode;
(function (FocusZoneMode) {
    FocusZoneMode[FocusZoneMode["Custom"] = 0] = "Custom";
    FocusZoneMode[FocusZoneMode["Wrap"] = 1] = "Wrap";
    FocusZoneMode[FocusZoneMode["Embed"] = 2] = "Embed";
})(FocusZoneMode || (FocusZoneMode = {}));
